"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerUsersPerms = void 0;
const enums_1 = require("../enums");
class ProducerUsersPerms {
    constructor(role) {
        this.role = role;
        this.institutionPerms = {
            all: false,
            canCreate: false,
            canRead: [],
            canUpdate: [],
            canDelete: [],
        };
        this.hasAdminAccess = [enums_1.UserRole.Admin, enums_1.UserRole.Api, enums_1.UserRole.SelfUser].indexOf(role) !== -1;
    }
    getUserRole() {
        return this.role;
    }
    isStageClipAdmin() {
        return this.hasAdminAccess;
    }
    allowUserToCreateInstitution() {
        this.institutionPerms.canCreate = true;
    }
    addInstitutionToRead(institutionsIds) {
        this.institutionPerms.canRead = [...this.institutionPerms.canRead, ...institutionsIds];
    }
    addInstitutionToUpdate(institutionsIds) {
        this.institutionPerms.canUpdate = [...this.institutionPerms.canUpdate, ...institutionsIds];
    }
    addInstitutionToDelete(institutionsIds) {
        this.institutionPerms.canDelete = [...this.institutionPerms.canDelete, ...institutionsIds];
    }
    canUserCreateInstitution() {
        return this.hasAdminAccess || this.institutionPerms.canCreate;
    }
    canUserReadInstitution(institutionId) {
        return this.hasAdminAccess || this.institutionPerms.canRead.indexOf(institutionId) !== -1;
    }
    canUserUpdateInstitution(institutionId) {
        return this.hasAdminAccess || this.institutionPerms.canUpdate.indexOf(institutionId) !== -1;
    }
    canUserDeleteInstitution(institutionId) {
        return this.hasAdminAccess || this.institutionPerms.canDelete.indexOf(institutionId) !== -1;
    }
    canUserCreateParticipantInInstitution(institutionId) {
        return this.hasAdminAccess || this.institutionPerms.canUpdate.indexOf(institutionId) !== -1;
    }
    canUserReadParticipantInInstitution(institutionId) {
        return this.hasAdminAccess || this.institutionPerms.canRead.indexOf(institutionId) !== -1;
    }
    canUserUpdateParticipantInInstitution(institutionId) {
        return this.hasAdminAccess || this.institutionPerms.canUpdate.indexOf(institutionId) !== -1;
    }
    canUserDeleteParticipantInInstitution(institutionId) {
        return this.hasAdminAccess || this.institutionPerms.canUpdate.indexOf(institutionId) !== -1;
    }
    getInstitutionsWithReadAccess() {
        return this.institutionPerms.canRead;
    }
    getInstitutionsWithUpdateAccess() {
        return this.institutionPerms.canUpdate;
    }
    getInstitutionsWithDeleteAccess() {
        return this.institutionPerms.canDelete;
    }
}
exports.ProducerUsersPerms = ProducerUsersPerms;
//# sourceMappingURL=producer-users-perms.js.map